import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 24}
        height={props.height ?? 24}
        fill="none"
        {...props}
    >
        <Path
            fill={props.color ?? ds.colorValue.icon.brand}
            d="M11.965 22c-2.546 0-4.765-.839-6.657-2.516-1.892-1.677-2.982-3.78-3.268-6.308h1.8c.297 2.032 1.21 3.717 2.742 5.054 1.53 1.337 3.325 2.005 5.383 2.005 2.293 0 4.238-.799 5.835-2.397 1.598-1.598 2.396-3.544 2.396-5.838s-.798-4.24-2.396-5.838c-1.597-1.598-3.542-2.397-5.835-2.397a7.856 7.856 0 0 0-3.611.856 8.887 8.887 0 0 0-2.902 2.356h3.076v1.765h-5.97V2.77h1.764v2.787A9.98 9.98 0 0 1 7.75 2.933 9.836 9.836 0 0 1 11.965 2c1.387 0 2.686.262 3.899.787a10.12 10.12 0 0 1 3.17 2.14c.901.903 1.614 1.96 2.14 3.173a9.716 9.716 0 0 1 .786 3.9 9.716 9.716 0 0 1-.787 3.9 10.128 10.128 0 0 1-2.14 3.172 10.121 10.121 0 0 1-3.17 2.14 9.705 9.705 0 0 1-3.898.788Zm3.53-5.262-4.378-4.38v-6.24h1.764v5.525l3.853 3.855-1.239 1.24Z"
        />
    </Svg>
);
export { SvgComponent as HistoryIcon };
